// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"8b0092f6","977":"a30e7b3e"}[chunkId] + ".chunk.js";
};